export const shouldMockAgentData = (): boolean => {
	return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
};
